// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__HfZoZ","body":"Modal_body__3CxwZ","header":"Modal_header__2E4Wf","footer":"Modal_footer__3n1fb"};